import { supabase } from './supabase';

/** Fields a card has, in form order. */
export const CARD_FIELDS = [
  'full_name', 'title', 'company', 'department',
  'email', 'phone', 'website', 'linkedin', 'twitter', 'instagram',
];

export const FIELD_LABELS = {
  full_name: 'Full name',
  title: 'Title',
  company: 'Company',
  department: 'Department',
  email: 'Email',
  phone: 'Phone',
  website: 'Website',
  linkedin: 'LinkedIn URL',
  twitter: 'X / Twitter URL',
  instagram: 'Instagram URL',
};

/** "José Pérez" -> "jose-perez" */
export const slugify = (text) =>
  (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'card';

const randomSuffix = () => Math.random().toString(36).slice(2, 6);

export const newCardSlug = (fullName) => `${slugify(fullName)}-${randomSuffix()}`;

export const publicCardUrl = (slug) => `${window.location.origin}/c/${slug}`;

/** A public card and its company's design, for the /c/:slug page. */
export async function getPublicCard(slug) {
  const { data: card, error } = await supabase
    .from('cards')
    .select('*')
    .eq('slug', slug)
    .eq('status', 'active')
    .maybeSingle();
  if (error) throw error;
  if (!card) return { card: null, theme: null };
  const theme = await getTheme(card.org_id);
  return { card, theme };
}

export async function getTheme(orgId) {
  const { data, error } = await supabase
    .from('brand_themes')
    .select('*')
    .eq('org_id', orgId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export async function getMyCards(userId) {
  const { data, error } = await supabase
    .from('cards')
    .select('*')
    .eq('user_id', userId)
    .order('created_at');
  if (error) throw error;
  return data || [];
}

export async function getCard(cardId) {
  const { data, error } = await supabase.from('cards').select('*').eq('id', cardId).maybeSingle();
  if (error) throw error;
  return data;
}
